import React from 'react'
import Lottie from 'react-lottie-player'
import loaderJson from '../../assets/img/Loader.json'
const InPageLoader = ({marginTop}) => {
  return (
   <div className={`${marginTop ?marginTop :'mt-7'}  rounded-xl flex justify-center items-center w-full bg-white`} style={{ minHeight: '550px' }}>
   <Lottie
     loop
     animationData={loaderJson}
     play
     style={{ maxWidth: "500px", maxHeight: "500px" }}
   />
 </div>
  )
}

export default InPageLoader